import React from 'react'
import { Link } from 'react-router-dom'
import blogData from '../../blogData'
import { slugify } from '../../validators/slugify'

export default function HomePageBlog() {
    let data = blogData[blogData.length -1]
    
    
    
    
    return (
        <>

            <div className="container" >
                            <div className="container-fluid">
                        <p className='text-center  ' style={{ paddingTop:"50px", paddingBottom:"20px", fontSize: "40px", fontWeight: "lighter", color: "#856A2b", fontFamily: "Cinzel" }}>Our Blog</p>
                                
                                <div className="row " style={{  paddingBottom:"35px"}}>
                                    <div className="col-md-8  " >
                                        <div >
                                            <img src={data.img} alt="Cochin Sightseeing"
                                                className=" rounded shadow-sm w-100"
                                                style={{ objectFit: "cover", }} />
                                        </div>
                                    </div>
                                    <div className="col-md-4 ">
                                        <p style={{textAlign:"justify",
                                             paddingBottom: "20px", fontSize: "28px", paddingTop:"30px", fontWeight:"bolder",  fontFamily: "Cinzel" }}>{data?.name}</p>
                                        <p style={{textAlign:"justify"}}>
                                          {data.description.split(" ").slice(0, 46).join(" ")}
                                            {data.description.split(" ").length > 46 && "..."}
                                        </p>
                                        <div style={{ paddingTop:"15px"}}>
                                            <Link to={`/blog/${slugify(data?.slug)}`} className='p-3 rounded' style={{backgroundColor:"#AD8B2a", color:"white", textDecoration:"none",}}>
                                            Read More
                                        </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
        </>
    )
}
